// https://vuex.vuejs.org/en/state.html

export default {
  status: '',
  token: localStorage.getItem('token') || '',
  tokenExpiry: localStorage.getItem('tokenExpiry') || '',
  user: localStorage.getItem('user') || {},
  locale: localStorage.getItem('locale') || process.env.I18N_LOCALE,
  account: localStorage.getItem('account') || '{}',
  calcTypes: [],
  priceRuleTypes: [],
  genders: [],
  countries: [],
  languages: [],
  newReservation: {},
  navigation: {},
  serviceTypes: [],
  prebuildTrip: null,
  prebuildBlock: null,
  serviceCategories: [],
  reservation: {}
}



// WEBPACK FOOTER //
// ./src/store/state.js